'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

interface NonBlockingDrawerProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * NonBlockingDrawer - A bottom drawer that allows interaction with page content
 * 
 * Unlike BottomSheet, this component:
 * - Does not block scrolling or clicks on the page
 * - Has no backdrop overlay
 * - Uses lower z-index to allow some content above it
 * - Includes subtle shadow for visual depth
 */
export function NonBlockingDrawer({ open, children, className }: NonBlockingDrawerProps) {
  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden pointer-events-auto">
      <div
        className={cn(
          'bg-white rounded-t-2xl shadow-2xl animate-in slide-in-from-bottom duration-150',
          className
        )}
      >
        <div className="flex justify-center pt-2 pb-1">
          <div className="w-10 h-1 bg-gray-300 rounded-full" />
        </div>
        {children}
      </div>
    </div>
  );
}
